'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _ExpanderButton = require('./ExpanderButton');

var _ExpanderButton2 = _interopRequireDefault(_ExpanderButton);

var _Footer = require('./Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _MenuBlock = require('./MenuBlock');

var _MenuBlock2 = _interopRequireDefault(_MenuBlock);

var _MenuGroupItem = require('./MenuGroupItem');

var _MenuGroupItem2 = _interopRequireDefault(_MenuGroupItem);

var _MenuGroupsDivider = require('./MenuGroupsDivider');

var _MenuGroupsDivider2 = _interopRequireDefault(_MenuGroupsDivider);

var _MenuGroupsList = require('./MenuGroupsList');

var _MenuGroupsList2 = _interopRequireDefault(_MenuGroupsList);

var _MenuItem = require('./MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _MenuItemFlyout = require('./MenuItemFlyout');

var _MenuItemFlyout2 = _interopRequireDefault(_MenuItemFlyout);

var _MenuItemTitle = require('./MenuItemTitle');

var _MenuItemTitle2 = _interopRequireDefault(_MenuItemTitle);

var _MenuItemTitleA = require('./MenuItemTitleA');

var _MenuItemTitleA2 = _interopRequireDefault(_MenuItemTitleA);

var _MenuItemTitleGhost = require('./MenuItemTitleGhost');

var _MenuItemTitleGhost2 = _interopRequireDefault(_MenuItemTitleGhost);

var _MenuItemTitleIcon = require('./MenuItemTitleIcon');

var _MenuItemTitleIcon2 = _interopRequireDefault(_MenuItemTitleIcon);

var _MenuItemTitleLink = require('./MenuItemTitleLink');

var _MenuItemTitleLink2 = _interopRequireDefault(_MenuItemTitleLink);

var _MenuItemTitleNoLink = require('./MenuItemTitleNoLink');

var _MenuItemTitleNoLink2 = _interopRequireDefault(_MenuItemTitleNoLink);

var _MenuItemTitleText = require('./MenuItemTitleText');

var _MenuItemTitleText2 = _interopRequireDefault(_MenuItemTitleText);

var _MenuSubItem = require('./MenuSubItem');

var _MenuSubItem2 = _interopRequireDefault(_MenuSubItem);

var _MenuSubItemA = require('./MenuSubItemA');

var _MenuSubItemA2 = _interopRequireDefault(_MenuSubItemA);

var _MenuSubItemLink = require('./MenuSubItemLink');

var _MenuSubItemLink2 = _interopRequireDefault(_MenuSubItemLink);

var _MenusList = require('./MenusList');

var _MenusList2 = _interopRequireDefault(_MenusList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  expanded: function expanded(_ref) {
    var theme = _ref.theme;
    return '\n    width: ' + theme.dimensions.leftNavWidth + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background-color: ' + theme.colors.base.chrome100 + ';\n  border-right: 1px solid ' + theme.colors.base.chrome200 + ';\n  box-sizing: border-box;\n  height: 100%;\n  position: relative;\n  transition: width ' + theme.dimensions.leftNavExpandTime + ';\n  width: ' + theme.dimensions.leftNavWidthCollapsed + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavExpandTime: _propTypes2.default.string.isRequired,
    leftNavWidth: _propTypes2.default.string.isRequired,
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

var LeftNav = (0, _decisivUiUtils.buildStyledComponent)('LeftNav', _styledComponents2.default.nav, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

LeftNav.ExpanderButton = _ExpanderButton2.default;
LeftNav.Footer = _Footer2.default;
LeftNav.MenuBlock = _MenuBlock2.default;
LeftNav.MenuGroupItem = _MenuGroupItem2.default;
LeftNav.MenuGroupsDivider = _MenuGroupsDivider2.default;
LeftNav.MenuGroupsList = _MenuGroupsList2.default;
LeftNav.MenuItem = _MenuItem2.default;
LeftNav.MenuItemFlyout = _MenuItemFlyout2.default;
LeftNav.MenuItemTitle = _MenuItemTitle2.default;
LeftNav.MenuItemTitleA = _MenuItemTitleA2.default;
LeftNav.MenuItemTitleGhost = _MenuItemTitleGhost2.default;
LeftNav.MenuItemTitleIcon = _MenuItemTitleIcon2.default;
LeftNav.MenuItemTitleLink = _MenuItemTitleLink2.default;
LeftNav.MenuItemTitleNoLink = _MenuItemTitleNoLink2.default;
LeftNav.MenuItemTitleText = _MenuItemTitleText2.default;
LeftNav.MenuSubItem = _MenuSubItem2.default;
LeftNav.MenuSubItemA = _MenuSubItemA2.default;
LeftNav.MenuSubItemLink = _MenuSubItemLink2.default;
LeftNav.MenusList = _MenusList2.default;

exports.default = LeftNav;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/LeftNav/index.js
// module id = 1576
// module chunks = 2